import { IReportConfigurationModel } from '../models/report-configuration.model';
import { Action, createReducer, on } from '@ngrx/store';
import * as ReportConfiguratuinActions from './report-configuration.actions';
export type State = IReportConfigurationModel;

const initialState: State = {
  findings: null,
  analysis: null
};

const settingsReducer = createReducer(
  initialState,

  on(ReportConfiguratuinActions.GetReportConfigurationsSuccess, (state, { configurations }): State => {
    const { findings, analysis } = configurations;
    return { ...state, findings, analysis };
  }),
  on(ReportConfiguratuinActions.SaveReportNameConfigurationSuccess, (state, { name, configurations }): State => {
    return { ...state, [name]: { ...state[name], name: configurations } };
  }),
  on(ReportConfiguratuinActions.SaveReportTabsConfigurationSuccess, (state, { name, configurations }): State => {
    return { ...state, [name]: { ...state[name], tabs: configurations } };
  }),
  on(ReportConfiguratuinActions.SaveReportColumnGroupsConfigurationSuccess, (state, { name, configurations }): State => {
    return { ...state, [name]: { ...state[name], columnGroups: configurations } };
  })
);

export const reducer = (state: State, action: Action): State => settingsReducer(state, action);
